
@if (registerUser()) {
  <div class="carousel-loader">
    <app-loader-carousel-swiper />
    
    <app-loader-carouse-text />
  </div>
}